
 import base from "./base.service";
 
 const instance = base.service();
 
 export const getAll = () => {
     return instance.get("/korisnik/all");
 }
 export const addKorisnik = (newKorisnik) =>
 {
    return instance.post(`/korisnik/zaposleni`, newKorisnik);
 };
 
 export const deleteKorisnik = (id) =>
 {
    return instance.delete(`/korisnik/${id}`);
 }
 export const promijeniLozinku = (data) => {
    return instance.post("/korisnik/promjena-lozinke", data);
  };

 export const deaktiviraj = (korisnickoIme) => {
  return instance.put(`/korisnik/deaktiviraj/${korisnickoIme}`);
};
export const aktiviraj = (korisnickoIme) => {
  return instance.put(`/korisnik/aktiviraj/${korisnickoIme}`);
};

  export const promijeniLozinkuAdmin = (data) => {
    return instance.post("/korisnik/promjena-lozinke-admin", data);
  };
  
 export const updateKorisnik = (korisnickoIme, korisnikData) => {
    return instance.put(`/korisnik/${korisnickoIme}`, korisnikData);
  };

  